/*
 * This file is generated by scripts/generate-ts-colors.ts DON'T MODIFY CONTENT HERE
 */

export enum Colors {
  background = '#f3f5f6',
  backgroundDarker = '#e3e5e8',
  backgroundGradient = 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(245, 248, 249, 0.99) 100%)',
  backgroundLight = '#f9fafb',
  backgroundWhite = '#ffffff',
  black = '#000000',
  border = '#d0d9dd',
  borderLight = '#e6f0f6',
  color = '#5a5f72',
  colorDark = '#444756',
  colorDarker = '#31343f',
  colorDarkest = '#24252d',
  colorDarkestX = '#1a1b24',
  colorGold = '#bd910c',
  colorGreen = '#1ab616',
  colorGreenSelected = '#2d7109',
  colorLeadPurple = '#7148bd',
  colorLight = '#7c8498',
  colorLighter = '#dce2e5',
  colorPrimary = '#1999e3',
  colorPrimaryDark = '#117cba',
  colorPrimaryDarker = '#0c6090',
  colorRed = '#e50101',
  colorScaleGreen = '#31bd95',
  colorYellow = '#f09a0f',
  contextPrivateBackgroundDarker = '#f2f2c3',
  hoverBackground = '#f1faff',
  personalColor = '#f09300',
  white = '#ffffff',
  withColorLight = 'linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(249, 250, 251, 1) 100%)',
}
